module.exports = __webpack_public_path__ + "img/fashion_47.d37a9ea3.jpg";